import type {
  ISaleRepository,
  CreateSaleInput,
  UpdateSaleInput,
  ListSalesParams,
  ListSalesResult,
  ReturnSaleInput,
  SaleStatsParams,
} from '@/features/sale/domain/repositories/ISaleRepository.js';
import type { SaleEntity, SaleStats } from '@/features/sale/domain/entities/SaleEntity.js';
import type { SaleItemEntity, SaleReturnItemEntity } from '@/features/sale/domain/entities/SaleItemEntity.js';
import type { SaleRemoteDataSource } from '@/features/sale/data/datasources/SaleRemoteDataSource.js';

export class SaleRepository implements ISaleRepository {
  constructor(private dataSource: SaleRemoteDataSource) {}

  async listSales(params: ListSalesParams): Promise<ListSalesResult> {
    return this.dataSource.listSales(params);
  }

  async getSaleDetail(saleId: string): Promise<{ sale: SaleEntity; items: SaleItemEntity[]; returnItems: SaleReturnItemEntity[] }> {
    return this.dataSource.getSaleDetail(saleId);
  }

  async createSale(input: CreateSaleInput): Promise<string> {
    return this.dataSource.createSale(input);
  }

  async updateSale(saleId: string, input: UpdateSaleInput): Promise<boolean> {
    return this.dataSource.updateSale(saleId, input);
  }

  async deleteSale(input: ReturnSaleInput): Promise<boolean> {
    return this.dataSource.deleteSale(input);
  }

  async cancelSale(input: ReturnSaleInput): Promise<boolean> {
    return this.dataSource.cancelSale(input);
  }

  async getSaleStats(params: SaleStatsParams): Promise<SaleStats> {
    return this.dataSource.getSaleStats(params);
  }
}
